import { Component, ElementRef, OnInit } from '@angular/core';
import { FormService } from "../../core/services/form.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Http, Response, URLSearchParams } from '@angular/http';
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SimpleGlobal } from "ng2-simple-global";
import { CommonService } from "../../core/services/common.service";
import { Form } from "../../core/models/form.model";
import { environment } from "../../../environments/environment";
import { validateEmail } from "../../common/validators/email-validator.directive";
import { validateAllowedCharacters } from "../../common/validators/allowed-characters-validator.directive";
import { validateNumericCharacters } from "../../common/validators/numeric-validator.directive";
import { validateLength } from "../../common/validators/length-validator.directive";

@Component({
    selector: 'app-form-show',
    templateUrl: './form-show.component.html',
    styleUrls: ['./form-show.component.css']
})
export class FormShowComponent implements OnInit {

    form: Form;
    token: string;
    recruiter_id: string;
    verificationForm: FormGroup;
    public filterParams: URLSearchParams = new URLSearchParams();
    detailsSubmitted: boolean;
    errorOccurred: boolean;

    // Create a new form data instance
    formData = new FormData();


    constructor(
        private route: ActivatedRoute,
        private formService: FormService,
        private fb: FormBuilder,
        private commonService: CommonService,
        protected http: Http,
        protected el: ElementRef,
        public global: SimpleGlobal,
        private router: Router,
    ) {
    }

    ngOnInit() {

        this.route.queryParams.subscribe(params => {

            Object.keys(params).forEach(key => {
                if (key == 'redirect') {

                }
                if (key == 'token') {
                    this.token = params[key];

                }
                else if (key == 'recruiter_id') {
                    this.recruiter_id = params[key];
                }
                else {
                    this.filterParams.set(key, params[key]);
                }

            });

            // Redirect every request to new page.
            this.router.navigate(['invites', params['candidate_id']], {queryParams:{recruiter_id : this.recruiter_id}});


            if (this.filterParams.get('redirect')) {

            }
            else {
                this.formService.find(this.token, this.filterParams).subscribe(response => {
                    console.log(response);
                    if (response['employee_id']) {
                        alert('This Employee Exists');
                    }
                    else {
                        this.form = response;
                        this.initForm();
                    }

                });
            }

        });

    }

    initForm() {
        this.verificationForm = this.fb.group({
            'name': [this.form.name, [Validators.required, validateAllowedCharacters('')]],
            'mobile_number': [this.form.mobile_number, [Validators.required, validateNumericCharacters(''), validateLength('10')]],
            'alternate_number': ['', validateNumericCharacters('')],
            'employment_type': ['experienced', [Validators.required]],
            'email': [this.form.email, [Validators.required, validateEmail()]],
            'client_employee_id': [''],
            'client_id': [this.recruiter_id],
            'expected_joining_date': [''],
            'identity_verifications': this.fb.array([this.initIdentityVerification()]),
            'education_verifications': this.fb.array([this.initEducationVerification()]),
            'employment_verifications': this.fb.array([this.initEmploymentVerification()]),
            'address_verifications': this.fb.array([this.initAddressVerification()]),
            'reference_verifications': this.fb.array([this.initReferenceVerification()]),
        });
    };

    submitDetails() {

        const url = environment.client_url + 'forms/' + this.token + '/upload';

        this.formService.submitForm(this.filterParams.get('candidate_id'), this.verificationForm.value).subscribe(
            response => {

                let employeeId = response['employee_id'];

                this.formData.append('employee_id', employeeId);

                this.http.post(url, this.formData)
                    .map((res: Response) => res.json()).subscribe(
                    (success) => {
                        this.detailsSubmitted = true;
                        this.form = null;
                        this.commonService.notifications.success('Details Submitted Successfully');
                    },
                    error => {
                        this.commonService.notifications.error('Some Error Occurred');
                        this.errorOccurred = true;
                        this.form = null;
                    }
                )
            },
            error => {
                this.commonService.notifications.error('Some Error Occurred');
                this.errorOccurred = true;
                this.form = null;
            }
        );

    }

    onFileChange(verification, index, type_of_doc) {

        // Locate the file element meant for the file upload.
        let inputEl: HTMLInputElement = this.el.nativeElement.querySelector('#' + verification + '_' + type_of_doc + '_' + index);

        // Get the total amount of files attached to the file input.
        let fileCount: number = inputEl.files.length;

        // Check if the file count is greater than zero, to be sure a file was selected.
        if (fileCount > 0) { // a file was selected

            if (verification == 'resume') {

                this.formData.append(verification + '_' + index + '_' + type_of_doc + '_file_' + 1, inputEl.files.item(0));

            }
            else {
                this.setDocumentCount(verification, type_of_doc, index);

                for (let i = 0; i < fileCount; i++) {

                    this.formData.append(verification + '_' + index + '_' + type_of_doc + '_file_' + i, inputEl.files.item(i));
                }
            }
        }
    }


    initIdentityVerification() {
        return this.fb.group({
            type_of_doc: [''],
            front_url: ['', [Validators.required]],
        });
    }

    initEducationVerification() {
        return this.fb.group({
            university_name: [''],
            college_name: [''],
            enrollment_number: [''],
            course: [''],
            passing_year: ['', [validateNumericCharacters(''), validateLength('4')]],
            cgpa: [''],
            document_degree: [null, [Validators.required]],
            document_marksheet: [null, [Validators.required]]
        });
    }

    initEmploymentVerification() {
        return this.fb.group({
            employment_company_name: [''],
            type: [''],
            joining_date: [''],
            end_date: [''],
            designation: [''],
            department: [''],
            salary: [''],
            reference_name: ['', [Validators.required, validateAllowedCharacters('')]],
            reference_number: ['', [validateNumericCharacters(''), validateLength('10')]],
            reference_email: ['', [validateEmail()]],
            hr_name: [''],
            hr_number: ['', [validateNumericCharacters(''), validateLength('10')]],
            hr_email: ['', [validateEmail()]],
            document_document: [null, [Validators.required]]
        });
    }

    initReferenceVerification() {
        return this.fb.group({
            reference_name: ['', [Validators.required, validateAllowedCharacters('')]],
            reference_mobile_number: ['', [validateNumericCharacters(''), validateLength('10')]],
            reference_relation: [''],
            reference_company_name: [''],
        });
    }

    initAddressVerification() {

        let config = {
            'current_address': [''],
            'current_state_id': [''],
            'current_state_name': [''],
            'current_district_id': [''],
            'current_district_name': [''],
            'current_pincode': ['', [validateNumericCharacters(''), validateLength('6')]],
            'current_landmark': [''],
            'permanent_address': [''],
            'permanent_state_id': [''],
            'permanent_state_name': [''],
            'permanent_district_id': [''],
            'permanent_district_name': [''],
            'permanent_pincode': ['', [validateNumericCharacters(''), validateLength('6')]],
            'permanent_landmark': [''],
        };

        return this.fb.group(config);
    }


    addNewRow(type) {

        const control = <FormArray>this.verificationForm.controls[type];

        if (type == 'identity_verifications') {
            control.push(this.initIdentityVerification());
        }

        if (type == 'education_verifications') {
            control.push(this.initEducationVerification());
        }

        if (type == 'employment_verifications') {
            control.push(this.initEmploymentVerification());
        }
        if (type == 'reference_verifications') {
            control.push(this.initReferenceVerification());
        }
    }

    deleteRow(type, index: number) {

        const control = <FormArray>this.verificationForm.controls[type];

        control.removeAt(index);
    }


    // Set the value of the form control state_id
    OnStateSelect(event, type) {

        let state = type + '_state_id';
        let district = type + '_district_id';

        let formArray = <FormArray>this.verificationForm.controls.address_verifications;

        formArray.controls[0].get(state).setValue(event.item.id);

        // Setting the default value on any change is selection of state.
        formArray.controls[0].get(district).setValue('');
    }

    // Set the value of the form control district_id
    OnDistrictSelect(event, type) {
        let district = type + '_district_id';

        let formArray = <FormArray>this.verificationForm.controls.address_verifications;

        formArray.controls[0].get(district).setValue(event.item.id);
    }

    onTypeOfDocChange(verification, index) {
        if (verification == 'identity_verifications') {
            let formArray = <FormArray>this.verificationForm.controls.identity_verifications;
            formArray.controls[index].get('front_url').setValue(null);
        }
    }

    setDocumentCount(verification: any, type_of_doc: any, index: any) {
        let formArray = <FormArray>this.verificationForm.controls[verification];
        formArray.controls[index].get(type_of_doc).setValue(1);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/form-show/form-show.component.ts